import { Box, Paper } from '@mui/material'
import { ProfileSettings } from 'pages/profile/components'

interface ProfileState {
  [key: string]: string | number | boolean
}

interface OnboardingProfileSettingsProps {
  profileState: ProfileState
  setProfileState: (state: ProfileState) => void
  editMode: boolean
  onSave?: (state: ProfileState) => void
}

export default function OnboardingProfileSettings({
  profileState,
  setProfileState,
  editMode,
  onSave,
}: OnboardingProfileSettingsProps) {
  const handleSave = (newState: ProfileState) => {
    setProfileState(newState)
    onSave?.(newState)
  }

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: 'white',
        borderRadius: 2,
        padding: 0,
        marginBottom: 3,
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'secondary.main',
          color: 'white',
          padding: 2,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
      </Box>

      <Box sx={{ padding: 3 }}>
        <ProfileSettings
          profileState={profileState}
          setProfileState={handleSave}
          editMode={editMode}
        />
      </Box>
    </Paper>
  )
}
